<template>
  <b-card no-body>
    <b-skeleton-img></b-skeleton-img>
    <b-card-body>
      <b-skeleton  height="10%"></b-skeleton>
      <b-skeleton  height="10%"></b-skeleton>
      <b-skeleton
        height="10%"
        width="40%"
      ></b-skeleton>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody ,BSkeleton, BSkeletonImg} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BCardBody,
    BSkeleton,
    BSkeletonImg
  },
};
</script>
